export default {
  INVALID_MARKET: 'invalid_market',
  DISALLOWED_ZIP: 'disallowed_zip',
  IS_HOMEOWNER: 'is_homeowner',
  MORATORIUM: 'moratorium',
};
